import { isEmpresaAgentesInmutable } from "@/composables/empresaAgentesAutoregistroValidada";

export function isDocumentacionEmpresaAgentesBloqueada(
  idEstado: string | null | undefined,
  autoregistro: boolean | undefined,
): boolean {
  return isEmpresaAgentesInmutable(idEstado, autoregistro);
}
